// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
// import "@hotwired/turbo-rails"
import "@popperjs/core"
import "bootstrap/dist/js/bootstrap.min"


// import JSViewer from "./jspectra_viewer"
// import JSViewerLatest from "./jspectra_viewer_latest"
// // import "./jspectraviewer_utilities_np_mrd"
// import './JSmol.min'
// // console.log("JSV", new JSViewer)
// console.log("d3", d3)
// // console.log($)
// // import * as $ from "./jquery-1.11.1"

// import "./controllers"

// import * as $ from "jquery"

// import * as jsv2 from "jsv2"
// console.log("jsv2", jsv2)
// // console.log("jquery", $)

import "./handle_submit"

// import "./jsv/x2js.min.js"
// import "./jsv/jsmol/JSmol.min.js"